<script>
	import { HorizontalBar } from 'vue-chartjs'


	export default {
        extends: HorizontalBar,

    data () {
        return {
            //
            chart_options: {
                legend: {
                    position: 'bottom',
                },
                title: {
                    display: true,
                    text: this.title_text
                },
                scales: {
                    xAxes:
                        [
                            {
                                "ticks":{
                                    max:100,
                                    "stepSize": 10,
                                    beginAtZero: true

                                }
                            }
                        ]
                    },
                responsive: true,
                maintainAspectRatio: false
                },
            datas: {}
        }

    },
        mounted () {

        },
        methods: {

            fetchDatas(datas) {

                this.renderChart(datas, this.chart_options);
            }

        },
	    props: {


            title_text:{
                type:String,
                required:false,
                default : 'Prestazioni erogate'
            }
        }

	}
</script>
